import { render, staticRenderFns } from "./footerPage.vue?vue&type=template&id=7e31e162&scoped=true"
import script from "./footerPage.vue?vue&type=script&lang=js"
export * from "./footerPage.vue?vue&type=script&lang=js"
import style0 from "./footerPage.vue?vue&type=style&index=0&id=7e31e162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e31e162",
  null
  
)

export default component.exports